const zhHant = {
  'lang.switch': '語言',
  'nav.home': '首頁',
  'nav.about': '關於我們',
  'nav.services': '核心服務',
  'nav.org': '組織架構',
  'nav.news': '最新消息',
  'nav.contact': '聯絡我們',
  'nav.admin': '管理面板',
  'nav.member': '會員專區',
  'nav.login': '登入',
  'nav.join': '加入會員',
  'nav.logout': '登出',
  'nav.backHome': '返回首頁',
  'nav.openMenu': '開啟選單',
  'nav.closeMenu': '關閉選單',
  'nav.dashboard': '儀表板',
  'nav.checkIn': '簽到',
  'nav.gifts': '禮品',
  'nav.events': '活動',
  'nav.members': '會員管理',
  'nav.content': '內容管理',
  'nav.messages': '聯絡訊息',
  'nav.advanced': '進階設定',
  'nav.profile': '個人資料',
  'nav.myQr': '我的QR碼',
  'nav.myEvents': '我的活動',
  'nav.password': '修改密碼',
  'role.volunteer': '義工',
  'role.adminLine': '管理員：',
  'login.title': '會員登入',
  'login.phone': '電話號碼',
  'login.phonePh': '請輸入電話號碼',
  'login.password': '密碼',
  'login.passwordPh': '請輸入密碼',
  'login.code': '驗證碼',
  'login.codePh': '驗證器上的 6 位數字',
  'login.submit': '登入',
  'login.submitting': '登入中...',
  'login.totpRequired': '請輸入驗證碼',
  'login.new': '還未成為會員？',
  'login.register': '立即註冊',
  'desk.scanPh': '掃描會員證',
  'desk.scanLabel': '櫃台掃描',
  'desk.checkInTitle': '簽到櫃台',
  'desk.checkInHint': '掃描後按 Enter 簽到。離線會先排隊（{n}）。',
  'desk.walkIn': '現場報名並簽到',
  'desk.giftTitle': '禮品櫃台',
  'desk.giftHint': '掃描後按 Enter 領取。離線會先排隊（{n}）。',
  'desk.remaining': '餘 {n}',
  'desk.guestPhone': '非會員電話（找不到會員時使用）',
  'desk.guestName': '非會員姓名',
  'desk.choose': '請選擇',
  'desk.queued': '已加入離線隊列',
  'desk.queuedOffline': '網絡中斷，已加入離線隊列',
  'desk.failed': '操作失敗',
  'desk.checked_in': '簽到成功',
  'desk.already_checked_in': '已經簽到',
  'desk.not_registered': '未報名',
  'desk.redeemed': '禮品領取成功',
  'desk.already_redeemed': '已經領取禮品',
  'desk.exhausted': '禮品已派完',
  'desk.card_revoked': '此卡已失效',
  'desk.not_found': '找不到會員',
  'desk.category': '會員類別不符合此活動',
  'desk.full': '名額已滿',
  'desk.expired': '會籍已過期',
  'desk.waitlisted': '已加入候補',
  'desk.ineligible': '未符合參加資格',
  'desk.closed': '報名已截止',
  'member.dash': '會員儀表板',
  'member.quick': '快速操作',
  'member.welcome': '歡迎回來，{name}！',
  'member.number': '會員編號',
  'member.joined': '加入日期',
  'member.news': '最新消息',
  'member.viewAll': '查看全部 →',
  'member.read': '閱讀',
  'member.noNews': '暫無最新消息',
  'member.events': '我的活動',
  'member.upcoming': '即將舉行',
  'member.registered': '已報名',
  'member.waitlist': '候補',
  'member.register': '報名',
  'member.cancel': '取消',
  'member.noWait': '沒有候補',
  'member.loadFail': '無法載入活動',
  'member.done': '已處理',
  'member.registerFail': '報名失敗',
  'member.cancelled': '已取消報名',
  'member.eventFallback': '活動',
  'qr.title': '我的QR碼',
  'qr.missing': '尚未建立會員 QR 碼，請聯絡管理員',
  'qr.loadFail': '無法獲取 QR 碼',
  'qr.number': '會員編號：',
  'qr.share': '分享電子會員卡',
  'qr.whatsapp': '分享至 WhatsApp',
  'qr.email': '電郵分享',
  'qr.copy': '複製連結',
  'qr.wallet': '加入錢包（需證書）',
  'qr.help': '使用說明',
  'qr.help1': '核對會員身份時，請出示此QR碼給工作人員掃描',
  'qr.help2': '請確保QR碼清晰可見',
  'qr.help3': '此QR碼為您的唯一識別碼，請勿與他人分享',
  'qr.shareText': '我的電子會員卡',
  'qr.mailSubject': '電子會員卡',
  'card.title': '電子會員卡',
  'card.missing': '找不到此會員卡',
  'card.number': '會員編號：',
  'card.expires': '到期：',
  'card.noExpiry': '無到期',
  'events.back': '返回活動',
  'events.edit': '編輯活動',
  'events.export': '匯出 Excel',
  'events.hint': '報名參加者，或為已報名會員簽到。',
  'events.registrants': '報名參加者',
  'events.searchPh': '會員編號、電話或姓名',
  'events.participants': '參加者',
  'events.none': '暫無報名',
  'events.checked': '已簽到',
  'events.checkInOne': '簽到參加者',
  'events.deleteReg': '刪除報名',
  'events.deleteAtt': '刪除簽到',
  'events.waitlist': '候補',
  'events.promote': '轉正',
  'events.promoted': '已轉正',
  'events.noWait': '沒有候補',
  'events.loading': '載入參加者...',
  'events.missing': '找不到活動',
  'events.confirmed': '已確認',
  'events.pending': '待確認',
  'events.cancelled': '已取消',
  'events.member': '會員',
  'events.confirmDelete': '確認刪除？',
  'events.deletedReg': '已刪除報名',
  'events.deletedAtt': '已刪除簽到',
  'events.deleteRegFail': '刪除報名失敗',
  'events.deleteAttFail': '刪除簽到失敗',
  'events.categories': '可參加類別（空白＝全部，例如 youth,senior）',
  'members.export': '匯出 Excel',
  'members.exported': '會員 Excel 已匯出',
  'adv.title': '進階設定',
  'adv.staff': '職員帳號',
  'adv.members': '會員進階',
  'adv.audit': '操作紀錄',
  'adv.totp': '雙重驗證',
  'adv.create': '建立帳號',
  'adv.save': '儲存',
  'adv.resetPw': '重設密碼',
  'adv.resetTotp': '重設雙重驗證',
  'adv.reissue': '補發會員卡',
  'adv.phone': '電話號碼',
  'adv.password': '密碼',
  'adv.email': '電郵',
  'adv.role': '角色',
  'adv.active': '帳戶有效',
  'adv.activeNote': '取消勾選後，此帳戶不能登入。',
  'totp.title': '職員雙重驗證',
  'totp.lead': '管理員和職員可使用驗證器 App。義工不需要。',
  'totp.start': '開始設定',
  'totp.secret': '密鑰：',
  'totp.code': '驗證碼',
  'totp.confirm': '確認啟用',
  'totp.later': '稍後設定',
  'totp.enabled': '雙重驗證已啟用',
  'totp.badCode': '驗證碼不正確',
  'role.admin': '管理員',
  'role.staff': '職員',
  'role.volunteerName': '義工',
};

const en = {
  'lang.switch': 'Language',
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.services': 'Services',
  'nav.org': 'Structure',
  'nav.news': 'News',
  'nav.contact': 'Contact',
  'nav.admin': 'Admin',
  'nav.member': 'Member area',
  'nav.login': 'Log in',
  'nav.join': 'Join',
  'nav.logout': 'Log out',
  'nav.backHome': 'Back to home',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',
  'nav.dashboard': 'Dashboard',
  'nav.checkIn': 'Check-in',
  'nav.gifts': 'Gifts',
  'nav.events': 'Events',
  'nav.members': 'Members',
  'nav.content': 'Content',
  'nav.messages': 'Messages',
  'nav.advanced': 'Settings',
  'nav.profile': 'Profile',
  'nav.myQr': 'My QR code',
  'nav.myEvents': 'My events',
  'nav.password': 'Password',
  'role.volunteer': 'Volunteer',
  'role.adminLine': 'Admin: ',
  'login.title': 'Member login',
  'login.phone': 'Phone',
  'login.phonePh': 'Enter your phone number',
  'login.password': 'Password',
  'login.passwordPh': 'Enter your password',
  'login.code': 'Verification code',
  'login.codePh': '6-digit code from your authenticator',
  'login.submit': 'Log in',
  'login.submitting': 'Signing in...',
  'login.totpRequired': 'Enter the verification code',
  'login.new': 'Not a member yet?',
  'login.register': 'Register',
  'desk.scanPh': 'Scan member card',
  'desk.scanLabel': 'Desk scan',
  'desk.checkInTitle': 'Check-in desk',
  'desk.checkInHint': 'Scan and press Enter. Offline scans queue ({n}).',
  'desk.walkIn': 'Register on site and check in',
  'desk.giftTitle': 'Gift desk',
  'desk.giftHint': 'Scan and press Enter to redeem. Offline scans queue ({n}).',
  'desk.remaining': '{n} left',
  'desk.guestPhone': 'Guest phone (when no member is found)',
  'desk.guestName': 'Guest name',
  'desk.choose': 'Choose',
  'desk.queued': 'Saved to the offline queue',
  'desk.queuedOffline': 'Network lost. Saved to the offline queue',
  'desk.failed': 'Action failed',
  'desk.checked_in': 'Checked in',
  'desk.already_checked_in': 'Already checked in',
  'desk.not_registered': 'Not registered',
  'desk.redeemed': 'Gift collected',
  'desk.already_redeemed': 'Already collected',
  'desk.exhausted': 'Gifts are used up',
  'desk.card_revoked': 'This card is no longer valid',
  'desk.not_found': 'Member not found',
  'desk.category': 'Membership category does not match this event',
  'desk.full': 'Event is full',
  'desk.expired': 'Membership has expired',
  'desk.waitlisted': 'Added to the waitlist',
  'desk.ineligible': 'Not eligible to join',
  'desk.closed': 'Registration is closed',
  'member.dash': 'Member dashboard',
  'member.quick': 'Shortcuts',
  'member.welcome': 'Welcome back, {name}!',
  'member.number': 'Member number',
  'member.joined': 'Joined',
  'member.news': 'News',
  'member.viewAll': 'View all →',
  'member.read': 'Read',
  'member.noNews': 'No news yet',
  'member.events': 'My events',
  'member.upcoming': 'Upcoming',
  'member.registered': 'Registered',
  'member.waitlist': 'Waitlist',
  'member.register': 'Register',
  'member.cancel': 'Cancel',
  'member.noWait': 'No one is waiting',
  'member.loadFail': 'Could not load events',
  'member.done': 'Done',
  'member.registerFail': 'Could not register',
  'member.cancelled': 'Registration cancelled',
  'member.eventFallback': 'Event',
  'qr.title': 'My QR code',
  'qr.missing': 'No member QR code yet. Please contact staff.',
  'qr.loadFail': 'Could not load the QR code',
  'qr.number': 'Member number: ',
  'qr.share': 'Share electronic card',
  'qr.whatsapp': 'Share on WhatsApp',
  'qr.email': 'Share by email',
  'qr.copy': 'Copy link',
  'qr.wallet': 'Add to wallet (certificate required)',
  'qr.help': 'How to use',
  'qr.help1': 'Show this QR code to staff when they check your membership',
  'qr.help2': 'Keep the code clear and easy to scan',
  'qr.help3': 'This code identifies you. Do not share it',
  'qr.shareText': 'My electronic member card',
  'qr.mailSubject': 'Electronic member card',
  'card.title': 'Electronic member card',
  'card.missing': 'This member card was not found',
  'card.number': 'Member number: ',
  'card.expires': 'Expires: ',
  'card.noExpiry': 'No expiry',
  'events.back': 'Back to events',
  'events.edit': 'Edit event',
  'events.export': 'Export Excel',
  'events.hint': 'Register participants, or check in someone who is registered.',
  'events.registrants': 'Registrations',
  'events.searchPh': 'Member number, phone, or name',
  'events.participants': 'Participants',
  'events.none': 'No registrations',
  'events.checked': 'Checked in',
  'events.checkInOne': 'Check in',
  'events.deleteReg': 'Delete registration',
  'events.deleteAtt': 'Delete check-in',
  'events.waitlist': 'Waitlist',
  'events.promote': 'Promote',
  'events.promoted': 'Promoted',
  'events.noWait': 'No one is waiting',
  'events.loading': 'Loading participants...',
  'events.missing': 'Event not found',
  'events.confirmed': 'Confirmed',
  'events.pending': 'Pending',
  'events.cancelled': 'Cancelled',
  'events.member': 'Member',
  'events.confirmDelete': 'Delete this record?',
  'events.deletedReg': 'Registration deleted',
  'events.deletedAtt': 'Check-in deleted',
  'events.deleteRegFail': 'Could not delete the registration',
  'events.deleteAttFail': 'Could not delete the check-in',
  'events.categories': 'Eligible categories (blank = all, e.g. youth,senior)',
  'members.export': 'Export Excel',
  'members.exported': 'Member Excel downloaded',
  'adv.title': 'Settings',
  'adv.staff': 'Staff accounts',
  'adv.members': 'Member tools',
  'adv.audit': 'Audit log',
  'adv.totp': 'Two-factor',
  'adv.create': 'Create account',
  'adv.save': 'Save',
  'adv.resetPw': 'Reset password',
  'adv.resetTotp': 'Reset two-factor',
  'adv.reissue': 'Reissue card',
  'adv.phone': 'Phone',
  'adv.password': 'Password',
  'adv.email': 'Email',
  'adv.role': 'Role',
  'adv.active': 'Account active',
  'adv.activeNote': 'If unchecked, this account cannot log in.',
  'totp.title': 'Staff two-factor',
  'totp.lead': 'Admins and staff can use an authenticator app. Volunteers do not need it.',
  'totp.start': 'Start setup',
  'totp.secret': 'Secret: ',
  'totp.code': 'Code',
  'totp.confirm': 'Turn on',
  'totp.later': 'Set up later',
  'totp.enabled': 'Two-factor is on',
  'totp.badCode': 'That code is not correct',
  'role.admin': 'Admin',
  'role.staff': 'Staff',
  'role.volunteerName': 'Volunteer',
};

export const dictionaries = {
  'zh-Hant': zhHant,
  en,
};

export function translate(lang, key, vars) {
  const table = dictionaries[lang] || dictionaries['zh-Hant'];
  const raw = table[key] ?? dictionaries['zh-Hant'][key] ?? key;
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, name) => (vars[name] == null ? '' : String(vars[name])));
}
